import LogList from "./LogList";

const Logs = {
  list: LogList,
};

export default Logs;
